import { render, staticRenderFns } from "./Greet.vue?vue&type=template&id=1c76e066&scoped=true"
import script from "./Greet.vue?vue&type=script&lang=js"
export * from "./Greet.vue?vue&type=script&lang=js"
import style0 from "./Greet.vue?vue&type=style&index=0&id=1c76e066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c76e066",
  null
  
)

export default component.exports